import { FinancialTransactionModel } from "domains/order/agreggates/payment/FinancialTransactionModel";
import { IOfflineCardData } from "modules/cardReader/domain/models/IOfflineCardData";
import { Payment } from "modules/order/domain/models/Payment";
import { TransactionType } from "modules/payment/domain/models/TransactionType";




type IDeviceInfo = {
  serialNumber: string;
  appVersion: string;
  timestamp: string;
};

const getDeviceInfo = async (): Promise<IDeviceInfo | null> => {
  const deviceInfo = await window.RNBridge.callNative("getDeviceInfo");
  return deviceInfo;
}

const printBase64 = async (base64: string) => {
  const result = await window.RNBridge.callNative("printBase64", base64);
  return result;
}

// openMsitefActions: async (params?: {config?: Partial<CommonOptions>}) => Promise<void>
const openMsitefActions = async (params?: { config?: SitefMetadata }): Promise<void> => {
  const result = await window.RNBridge.callNative("openMsitefActions", params);
  return result;
}

const printString = async (text: string) => {
  console.log("printString: ", text);
  const result = await window.RNBridge.callNative("printString", { text });
  return result;
}



export enum TypeTransaction {
  DEBIT = 'DEBIT',
  CREDIT = 'CREDIT',
}
// export type TxParams = {
//   amount: number;
//   typeTransaction?: TypeTransaction;
//   creditType?: CreditType;
//   installment?: number;
//   isTyped?: boolean;
//   isPreAuth?: boolean;
//   interestType?: InterestType;
//   printReceipt?: boolean;
// };


export interface SitefMetadata {
  tokenRegistroTls: string;
  comExterna?: string;
  empresaSitef: string;
  enderecoSitef: string;
  CNPJ_CPF: string;
  cnpj_automacao?: string;
  dadosSubAdqui?: string;
  terminalSitef?: string;
}
interface ITransactionParamCommon {
  amount: number;
  typeTransaction: TransactionType;
  token: string;
  printReceipt?: boolean;
  /** Id do pedido: o app grava o pagamento em disco e o recupera se cair com o m-SiTef aberto */
  operationId?: string;
}

interface ITransactionParamDirectpin extends ITransactionParamCommon {
  aquirer: 'directpin';
}
interface ITransactionParamMsitef extends ITransactionParamCommon {
  aquirer: 'msitef';
  metadata?: SitefMetadata;

}

export type ITransactionParams = ITransactionParamDirectpin | ITransactionParamMsitef;


export type InitResponse = {
  type: string;
  result: boolean;
  message: string;
};

export type TransactionResponse = Payment

export type ReadCardResponse = {
  uid: string;
  success?: boolean;
  message?: string;
  offlineCardData?: IOfflineCardData;
  isClosed?: boolean;
};




export interface FacialRecognitionResponse {
  success: boolean;
  message: string;
  data: any;
}


const initPayment = async (token: string): Promise<InitResponse> => {
  const result = await window.RNBridge.callNative("initPayment", token);
  return result;
}

const transaction = async (params: ITransactionParams): Promise<TransactionResponse> => {
  const result = await window.RNBridge.callNative("transaction", params);
  return result;
}

const readCard = async (onlyUid?: boolean, disableBeep?: boolean): Promise<ReadCardResponse> => {
  const result = await window.RNBridge.callNative("readCard", { onlyTag: onlyUid ?? false, disableBeep: disableBeep ?? false });
  console.log("readCard", result);
  return result;  
}

const abortReadCard = async (): Promise<void> => {
  // Chamado por código compartilhado (disableSensor) nas duas plataformas — no
  // CefSharp não existe abort, então vira no-op em vez de estourar.
  if (!("RNBridge" in window)) return;
  await window.RNBridge.callNative("abortReadCard");
}

const addListenerOnCardRemoved = (callback: () => void): void => {
  window.RNBridge.register("onCardRemovedCallback", callback);
}

const writeOfflineBalance = async (tag: string, value: number): Promise<void> => {
  await window.RNBridge.callNative("writeBalance", { tag, balance: value });
}


export const writeOfflineCard = async (
  data: IOfflineCardData,
): Promise<{
  success: boolean;
  message: string;
}> => {
  console.log("[ReactNativeBridge] writeOfflineCard", data);
  const result = await window.RNBridge.callNative("writeCard", { ...data });
  return result;
}



/** Pagamento m-SiTef que o app gravou em disco (ver getPendingPayment no app) */
export interface PendingNativePayment {
  operationId: string;
  /** PENDING: o m-SiTef abriu e não devolveu nada; RESULT: o retorno foi gravado */
  status: "PENDING" | "RESULT";
  /** m-SiTef ainda aberto (o resultado ainda vai chegar) */
  inProgress?: boolean;
  startedAt: number;
  finishedAt?: number;
  /** Requisição enviada ao m-SiTef, sem credenciais (valor em centavos, numeroCupom, data, hora) */
  request?: Record<string, string>;
  /** Só em RESULT: mesmo formato do retorno de transaction */
  payment?: TransactionResponse;
}

export interface MsitefOperationResult {
  success: boolean;
  code: string;
  message: string;
  transaction?: Record<string, any>;
  raw?: Record<string, any>;
}

/** null quando não há pagamento gravado ou o app é de uma versão sem a recuperação */
const getPendingPayment = async (): Promise<PendingNativePayment | null> => {
  try {
    return (await window.RNBridge.callNative("getPendingPayment", undefined, { timeout: 10000 })) ?? null;
  } catch (_error) {
    const error = _error as any;
    if (String(error?.message ?? "").includes("Native handler not found")) {
      return null;
    }
    throw error;
  }
};

const ackPayment = async (operationId: string): Promise<boolean> => {
  try {
    return await window.RNBridge.callNative("ackPayment", { operationId }, { timeout: 10000 });
  } catch (error) {
    console.warn("ackPayment falhou", error);
    return false;
  }
};

/** Modalidade administrativa do m-SiTef (130 pendências, 114 último comprovante) */
const msitefOperation = async (modalidade: string, metadata: SitefMetadata): Promise<MsitefOperationResult> => {
  return window.RNBridge.callNative("msitefOperation", { modalidade, metadata });
};

export { getPendingPayment, ackPayment, msitefOperation };
export { getDeviceInfo, printBase64, printString, initPayment, transaction, readCard, abortReadCard, openMsitefActions, addListenerOnCardRemoved, writeOfflineBalance };

